import { useEffect } from 'react';

interface UseClampedPageParams {
    page: number;
    pageSize: number;
    totalCount: number | undefined;
    onPageChange: (page: number) => void;
}

export function useClampedPage({
    page,
    pageSize,
    totalCount,
    onPageChange,
}: UseClampedPageParams): void {
    useEffect(() => {
        if (totalCount === undefined || pageSize <= 0) return;
        const lastPage = Math.max(Math.ceil(totalCount / pageSize), 1);
        if (page > lastPage) onPageChange(lastPage);
    }, [page, pageSize, totalCount, onPageChange]);
}
